import React, { useEffect, createElement } from 'react';
import { Home } from './pages/Home';
const PAGE_TITLE = 'Bonaire 2026 | Buceo y Navegación';
const PAGE_DESCRIPTION = 'Viaje grupal de buceo a Bonaire del 30 de agosto al 6 de septiembre de 2026. Grupo reducido de 12 buceadores. Reserva tu lugar con Buceo y Navegación.';
function upsertMeta(selector: string, attr: string, key: string, content: string) {
  let el = document.head.querySelector<HTMLMetaElement>(selector);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}
export function App() {
  useEffect(() => {
    // Browser tab + SEO title
    document.title = PAGE_TITLE;
    // SEO description + social sharing previews
    upsertMeta('meta[name="description"]', 'name', 'description', PAGE_DESCRIPTION);
    // Open Graph (Facebook, WhatsApp, LinkedIn)
    upsertMeta('meta[property="og:title"]', 'property', 'og:title', PAGE_TITLE);
    upsertMeta('meta[property="og:description"]', 'property', 'og:description', PAGE_DESCRIPTION);
    upsertMeta('meta[property="og:type"]', 'property', 'og:type', 'website');
    // Twitter / X
    upsertMeta('meta[name="twitter:card"]', 'name', 'twitter:card', 'summary_large_image');
    upsertMeta('meta[name="twitter:title"]', 'name', 'twitter:title', PAGE_TITLE);
    upsertMeta('meta[name="twitter:description"]', 'name', 'twitter:description', PAGE_DESCRIPTION);
  }, []);
  return <Home data-id="element-0" />;
}